import React from 'react';
import { TrendingUp, Leaf } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const VisitorBoost = () => {
  const { t } = useLanguage();

  return (
    <section className="my-12">
      <div className="container-custom">
        <div className="bg-gradient-to-r from-green-500 to-green-700 rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3 mb-4 md:mb-0">
            <Leaf className="h-8 w-8 text-white" />
            <h2 className="text-lg md:text-xl font-extrabold text-white leading-tight">
              {t('visitor-boost-title')}
              <span className="inline-flex items-center gap-1 ml-2">
                <TrendingUp className="h-6 w-6 text-white" />
                <span className="underline font-bold">{t('visitor-boost-increase')}</span>
              </span>
              {t('visitor-boost-achieve')}
            </h2>
          </div>
          <div className="text-white text-sm md:text-base font-semibold max-w-lg text-center md:text-left">
            {t('visitor-boost-description')}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisitorBoost; 